// Animated terminal-style ellipsis ( . .. ... ) used in place of the "→"
// arrow on call-to-action buttons, echoing the matrix-rain motif. The
// animation lives in index.html (@keyframes rain-dots); this is purely the
// markup hook. Fixed 3ch width so the button never reflows as dots cycle.
export function Dots() {
  return <span className="rain-dots" aria-hidden="true" />;
}
